import * as React from "react";
const SvgIcCross = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "4.25 4.25 11.5 11.5", ...props }, /* @__PURE__ */ React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeWidth: 1.5, d: "M15 5 5 15m10 0L5 5" }));
export default SvgIcCross;
